import { useMemo } from "react";
import "./MainTitle.scss";
import { theme, Button, Typography, Image } from "antd";
import { MenuOutlined, HomeOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";

export default function MainTitle({
  onTitleClick,
  setIsOpened,
  isMobile,
  isMenuIconVisible,
}) {
  const { useToken } = theme;
  const { token } = useToken();
  const { shop, loading: shopLoading } = useSelector(
    (state) => state?.shopDetails
  );

  const dimensionOfImage = useMemo(() => {
    return isMobile ? "24px" : "32px";
  }, [isMobile]);

  return (
    <div className="appMainTitle-cont">
      {isMobile && isMenuIconVisible ? (
        <Button
          icon={
            <MenuOutlined
              style={{
                color: token?.icons?.whiteIcon,
                fontSize: "24px",
              }}
            />
          }
          type="text"
          onClick={() => {
            if (setIsOpened && typeof setIsOpened === "function") {
              setIsOpened(true);
            }
          }}
        />
      ) : null}
      {shopLoading ? (
        ""
      ) : (
        <div className="appMainTitle-cont__content" onClick={onTitleClick}>
          {/* Show logo if it exists */}
          {shop?.extra_config?.preferences?.logo ? (
            <Image
              src={shop?.extra_config?.preferences?.logo}
              alt="Shop Logo"
              preview={false}
              style={{
                marginRight: shop?.is_name_visible_on_shop ? 8 : 0,
                width: dimensionOfImage,
                height: dimensionOfImage,
                borderRadius: "4px",
              }}
            />
          ) : null}
          {/* Show name if visible */}
          {shop?.name && shop?.is_name_visible_on_shop ? (
            <Typography.Text
              className="appMainTitle-cont__title"
              style={{
                color: token?.Typography?.mainColorText,
                cursor: "pointer",
              }}
              ellipsis={{
                tooltip: {
                  title: shop?.name,
                },
              }}>
              {shop?.name}
            </Typography.Text>
          ) : null}

          {/* Show default icon if neither logo exists nor name is visible */}
          {!shop?.extra_config?.preferences?.logo &&
          !shop?.is_name_visible_on_shop ? (
            <Button
              type="text"
              icon={
                <HomeOutlined
                  style={{
                    color: token?.colorPrimary,
                    fontSize: dimensionOfImage,
                  }}
                />
              }
            />
          ) : null}
        </div>
      )}
    </div>
  );
}
